import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import KpiSummaryBarChart from "./../KpiSummaryBarChart";
// import { getFailedKpiReport } from "../../UserFunctions";
import MiniLoader from "../../../utilityComponents/MiniLoader";
import { fetchSummaryDataCountForExecution } from "./../../../actions/KpiSummaryDashboardEnhanced/KpiSummaryLevelOneAction";
import KpiSummaryScenarioMetaInfo from "./KpiSummaryScenarioMetaInfo";
import PropTypes from "prop-types";


class KpiSummaryLevelOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        if (this.props.tdata.topologyUuid != undefined) {
            const payload = this.props.tdata.topologyUuid;
            this.props.getSummaryDataCountForExecution(payload);
        }
    }

    // downloadFailedKpireport(event) {
    //     this.setState({ loading: true });
    //     event.preventDefault();
    //     const payload = {
    //         // cad_topology_job_uuid: this.state.topology_job_id,
    //         cad_topology_job_uuid: this.props.tdata.topologyUuid,
    //     };
    //     getFailedKpiReport(payload).then((response) => {
    //         if (response && response.status === 200) {
    //             this.setState((prevState) => {
    //                 return {
    //                     loading: false,
    //                 };
    //             });
    //             const fileName = response.headers["content-disposition"].split("filename=")[1];
    //             const url = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement("a");
    //             link.href = url;
    //             link.setAttribute("download", fileName);
    //             document.body.appendChild(link);
    //             link.click();
    //         } else {
    //             this.setState((prevState) => {
    //                 return {
    //                     loading: false,
    //                 };
    //             });
    //         }
    //     });
    // }

    render() {
        return (
            <div>
                {this.props.loading ? (
                    <MiniLoader />
                ) : this.props.error ? (
                    <Alert key="danger" variant="danger">
                        {this.props.error}
                    </Alert>
                ) : this.props.successSummaryData.total_base_scenarios ===
                  undefined ? (
                    <Alert key="info" variant="info">
                        No records found for this cad topology !
                    </Alert>
                ) : (
                    <div>
                        <div className="row" style={{ margin: "1% 0%" }}>
                            <div
                                className="col-md-12"
                                style={{ paddingBottom: "1rem" }}
                            >
                                <KpiSummaryScenarioMetaInfo />
                            </div>
                            <div className="col-md-12">
                                <div
                                    className="card"
                                    style={{
                                        border: "solid #757AF7",
                                        height: "100%",
                                    }}
                                >
                                    <div
                                        className="card-header"
                                        style={{
                                            backgroundColor: "#757AF7",
                                            color: "#FFFFFF",
                                            fontWeight: "bold",
                                            borderRadius: "0%",
                                            padding: "0.5rem",
                                        }}
                                    >
                                        Scenario details
                                    </div>
                                    <div className="card-body">
                                        <div
                                            className="row"
                                            style={{ paddingBottom: "0.5rem" }}
                                        >
                                            <div className="col-md-6">
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        backgroundColor:
                                                            "#E2E3FF",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Base Scenario&apos;s
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_base_scenarios
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        backgroundColor:
                                                            "#bbf3bc",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Good Base
                                                        Scenario&apos;s
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_good_base_scenario
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        // backgroundColor: "#E2E3FF",
                                                        backgroundColor:
                                                            "#fdd048",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Not Good Base
                                                        Scenario&apos;s
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_not_good_base_scenario
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        backgroundColor:
                                                            "#E2E3FF",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Scenario
                                                        Variations
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_variations
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        backgroundColor:
                                                            "#bbf3bc",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Good Scenario
                                                        Variations
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_good_variations
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    className="row mytab"
                                                    id="hover"
                                                    style={{
                                                        // backgroundColor: "#E2E3FF",
                                                        backgroundColor:
                                                            "#fdd048",
                                                        fontSize: "1rem",
                                                        color: "#464646",
                                                        margin: "2% 0%",
                                                        padding: "1%",
                                                    }}
                                                >
                                                    <div
                                                        className="col-md-6 text-left"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        Total Not Good Scenario
                                                        Variations
                                                    </div>
                                                    <div
                                                        className="col-md-6 text-right"
                                                        style={{
                                                            color: "#464646",
                                                            display:
                                                                "inline-block",
                                                        }}
                                                    >
                                                        {
                                                            this.props
                                                                .successSummaryData
                                                                .total_not_good_variations
                                                        }
                                                    </div>
                                                </div>
                                                {/* {this.props.tdata.topologyName ? (
                                                    <div
                                                        className="row"
                                                        style={{
                                                            backgroundColor: "#E2E3FF",
                                                            fontSize: "1rem",
                                                            color: "#464646",
                                                            margin: "25% 0% 0%",
                                                            padding: "1%",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <div
                                                            className="align-items-center d-flex justify-content-center"
                                                            style={{ padding: "1%" }}
                                                        >
                                                            <button
                                                                onClick={(e) => {
                                                                    this.downloadFailedKpireport(e);
                                                                }}
                                                                className="btn btn-lg"
                                                                style={{
                                                                    backgroundColor: "#753dff",
                                                                    padding: "2%",
                                                                    fontSize: "1.1rem",
                                                                }}
                                                            >
                                                                Download YAML Report
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : undefined}
                                                {this.state.loading && <MiniLoader />} */}
                                            </div>
                                        </div>
                                        <div
                                            className="row"
                                            style={{ paddingTop: "0.5rem" }}
                                        >
                                            <div className="col-md-6">
                                                <div
                                                    className="card"
                                                    style={{
                                                        border: "solid #757AF7",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <div
                                                        className="card-header"
                                                        style={{
                                                            backgroundColor:
                                                                "#757AF7",
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            borderRadius: "0%",
                                                            padding: "0.5rem",
                                                        }}
                                                    >
                                                        Good/Not-Good Base
                                                        Scenario graphical
                                                        representation
                                                    </div>
                                                    <div className="card-body">
                                                        <div
                                                            className="row mytab"
                                                            id="hover"
                                                            style={{
                                                                backgroundColor:
                                                                    "#E2E3FF",
                                                                fontSize:
                                                                    "1rem",
                                                                color: "#464646",
                                                                margin: "1% 0%",
                                                                padding: "1%",
                                                            }}
                                                        >
                                                            <div className="col-md-12 text-left">
                                                                <KpiSummaryBarChart
                                                                    labels={[
                                                                        "good base scenarios",
                                                                        "not-good base scenarios",
                                                                    ]}
                                                                    sceneData={[
                                                                        this
                                                                            .props
                                                                            .successSummaryData
                                                                            .total_good_base_scenario,
                                                                        this
                                                                            .props
                                                                            .successSummaryData
                                                                            .total_not_good_base_scenario,
                                                                    ]}
                                                                ></KpiSummaryBarChart>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="card"
                                                    style={{
                                                        border: "solid #757AF7",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <div
                                                        className="card-header"
                                                        style={{
                                                            backgroundColor:
                                                                "#757AF7",
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            borderRadius: "0%",
                                                            padding: "0.5rem",
                                                        }}
                                                    >
                                                        Good/Not-Good Scenario
                                                        Variation graphical
                                                        representation
                                                    </div>
                                                    <div className="card-body">
                                                        <div
                                                            className="row mytab"
                                                            id="hover"
                                                            style={{
                                                                backgroundColor:
                                                                    "#E2E3FF",
                                                                fontSize:
                                                                    "1rem",
                                                                color: "#464646",
                                                                margin: "1% 0%",
                                                                padding: "1%",
                                                            }}
                                                        >
                                                            <div className="col-md-12 text-left">
                                                                <KpiSummaryBarChart
                                                                    labels={[
                                                                        "good scenarios",
                                                                        "not-good scenarios",
                                                                    ]}
                                                                    sceneData={[
                                                                        this
                                                                            .props
                                                                            .successSummaryData
                                                                            .total_good_variations,
                                                                        this
                                                                            .props
                                                                            .successSummaryData
                                                                            .total_not_good_variations,
                                                                    ]}
                                                                ></KpiSummaryBarChart>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ margin: "1% 0%" }}>
                            <div
                                className="col-md-6"
                                style={{
                                    backgroundColor: "#E2E3FF",
                                    textAlign: "center",
                                    margin: "1% 0%",
                                    padding: "1%",
                                }}
                            >
                                <Link
                                    to={{
                                        pathname:
                                            "/KpiSummaryScenarioFilterDashboard",
                                    }}
                                    style={{ textDecoration: "none" }}
                                    // target="_blank"
                                >
                                    <button style={{ padding: "0.5%", backgroundColor: "#757AF7" }}>
                                        Scenario Detailed Summary
                                    </button>
                                </Link>
                            </div>
                            <div
                                className="col-md-6"
                                style={{
                                    backgroundColor: "#E2E3FF",
                                    textAlign: "center",
                                    margin: "1% 0%",
                                    padding: "1%",
                                }}
                            >
                                <Link
                                    to={{
                                        pathname: "/KpiSummaryLevelThree",
                                        data: {
                                            cadId: this.props.tdata
                                                .topologyUuid,
                                        },
                                    }}
                                    style={{ textDecoration: "none" }}
                                    // target="_blank"
                                >
                                    <button style={{ padding: "0.5%", backgroundColor: "#757AF7" }}>
                                        KPI Detailed Summary
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tdata: state.topologyData.topologyData,
    // summaryDetails: state.KpiSummaryLevelOneData.summaryDetails,
    loading: state.KpiSummaryLevelOneData.loading,
    successSummaryData: state.KpiSummaryLevelOneData.successSummaryData,
    error: state.KpiSummaryLevelOneData.error,
});

const mapDispatchToProps = (dispatch) => ({
    getSummaryDataCountForExecution: (payload) =>
        dispatch(fetchSummaryDataCountForExecution(payload)),
});

KpiSummaryLevelOne.propTypes = {
    tdata: PropTypes.object,
    getSummaryDataCountForExecution: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string,
    successSummaryData: PropTypes.object
};
KpiSummaryLevelOne.defaultProps = {
    tdata: {},
    loading: false,
    error: '',
    successSummaryData: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(KpiSummaryLevelOne);
